const TWEEN = require('./tween.js').TWEEN
const THREE = require('three')
require('./DRACOLoader.js')(THREE)
require('./GLTFLoader.js')(THREE)

import app from './app.js'

app.loadMain = function() {

    loadGltf()

    let skinObj = []
    let allMesh = []

    function loadGltf(data) {
        const loader = new THREE.GLTFLoader();
        THREE.DRACOLoader.setDecoderPath('gltf/')
        loader.setDRACOLoader(new THREE.DRACOLoader());

        var textureLoader = new THREE.TextureLoader()
        /*var envMapTexture = textureLoader.load('/img/baibai.png')*/
        /*envMapTexture.mapping = THREE.SphericalReflectionMapping*/

        loader.load('data/model/obj.obj', function(gltf) { // 模型加载
            gltf.scene.traverse(function(child) {
                if (child.isMesh) {
                    child.updateMatrixWorld(true)

                    //需要透明的看不到的模型
                    if (child.name.indexOf('_OP') >= 0) {
                        child.material.needsUpdate = true
                        child.visible = true
                        child.renderOrder = 0
                        child.material = app.SkinMaterial
                    } else {
                        child.visible = true
                        child.renderOrder = 5
                        child.role === 'system'
                        /*child.material.envMap = envMapTexture*/
                        child.material.envMapIntensity = .3
                        child.material.side = THREE.doubleside
                        allMesh.push(child)
                    }
                }
            })

            app.scene.add(gltf.scene)
            handleAllmesh()
            app.reactDomComponent.loadFinish()

            let Group = app.groupLinkToMesh[app.adjustName(showmefirst)]

            if(Group){
                app.clickOption(Group)
            /*    console.log(app.adjustName(showmefirst))
            console.log(Group)*/
            }

        }, function(xml) {
            if (xml.loaded) {
                let cun = parseInt(xml.loaded / xml.total * 100)
                app.reactDomComponent.updataLoading(cun)
            } else {
                app.reactDomComponent.setState({
                    showloadingBar: false
                })
            }
        }, function(e) {
            console.log(e)
            app.reactDomComponent.handleLoadFail()
        });

    }

    //处理所有的加载结束的模型
    function handleAllmesh() {

        let objectsMateri = []

        
        allMesh.map((child, index) => {

            app.cloneMultiMaterial(objectsMateri, child)
            let mat = child.material
            mat.needsUpdate = true
            mat.transparent = true
            mat.metalness = 0
            child.originalMaterial = mat
            mat.originalColor = mat.color


            let meshName = child.name
            let tailStr2 = meshName.substr(meshName.length - 2, 2)
            let tailStr3 = meshName.substr(meshName.length - 3, 3)

            if(tailStr2 ==='_0' || tailStr2 ==='_1'){
                meshName = meshName.substr(0,meshName.length - 2)
            }


            //console.log(app.adjustName(meshName))

            let Group = app.groupLinkToMesh[app.adjustName(meshName)]

            

            if (Group) {
                app.objects.push(child)
                app.optionObj.push(child)
                //系统解剖部位
                child.dataParent = Group
                Group.children.push(child)
            } else {
                console.log(meshName + '')
            }

            renderObjMaterial(child, matType)
            
        })

    }


}


//模型材质的列表和渲染
const renderObjMaterial = function(obj, str) {
    //roughness 高光范围  数值越小范围越小越精致
    //normalScale 法线强度  数值越大 越强
    const materialArr = {
        bone: {
            normalScale: .4,
            roughness: .4
        },
        gulianjie: {
            roughness: .2
        },
        pifu: {
            normalScale: 0.002,
            roughness: .45
        },
        muscle: {
            normalScale: 10,
            roughness: .4
        },
        rendai: {
            normalScale: 0.001,
            roughness: .3
        },
        naobu: {
            normalScale: 0.02,
            roughness: .3
        },
        danse: {
            normalScale: 0.00001,
            roughness: .05
        },
        zhongshu: {
            normalScale: 0.001,
            roughness: .3
        },

        jirouwugaoguang: {
            normalScale: .5,
            roughness: .07
        },
        qiguan: {
            normalScale: 0.3,
            roughness: .1
        }
    }

    function renderObj(obj) {
        let aa = obj.material
        aa.side = THREE.DoubleSide
        aa.flatShading = false
        aa.needsUpdate = true
        aa.transparent = true
        aa.metalness = 0
        aa.metalnessMap = null
        aa.roughness = materialArr[str].roughness
        aa.normalScale = new THREE.Vector2(materialArr[str].normalScale, -materialArr[str].normalScale)
    }

    renderObj(obj)
}

//处理材质重复共用等各种问题
app.cloneMultiMaterial = function(arr, obj) {
    // 如果有模型使用同一材质  
    //如果一个模型有多个材质
    let flat = false
    let Mlen = arr.length
    //查看是否有模型使用同一材质
    for (var i = 0; i < Mlen; i++) {
        if (arr[i] === obj.material) {
            obj.material = arr[i].clone()
            flat = true
            break
        }
    }!flat ? arr.push(obj.material) : null
}













// WEBPACK FOOTER //
// ./src/pages/webgl/src/load.js